module.exports = __webpack_public_path__ + "img/solar-panel.e688ad72.svg";